"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6717],{

/***/ 6717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgToilet = function SvgToilet(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M10.48 6.333H4.667v-5a1 1 0 0 0-1.961-.26A.99.99 0 0 0 2.334 1H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h.407l.585 2.341-.652 3.26a.334.334 0 0 0 .327.4h8a.333.333 0 0 0 .323-.415l-.612-2.435a3.296 3.296 0 0 0 .77-1.818h.334a.937.937 0 0 0 .852-1 .937.937 0 0 0-.854-1Zm-7.146-5a.333.333 0 1 1 .666 0v5h-.666v-5ZM.667 6V2A.333.333 0 0 1 1 1.667h1.334A.333.333 0 0 1 2.667 2v4a.333.333 0 0 1-.333.333H1A.333.333 0 0 1 .667 6Zm7.792 4.114a2.638 2.638 0 0 1-1.625.553.333.333 0 1 0 0 .667 3.3 3.3 0 0 0 1.988-.663l.418 1.663H2.074L2.66 9.4v-.007a1.324 1.324 0 0 0 0-.133v-.007L2.094 7h.24c.018 0 .036-.005.054-.005-.036.11-.054.223-.054.338a.937.937 0 0 0 .854 1H9.48a2.646 2.646 0 0 1-1.021 1.781Zm2.02-2.447h-7.29c-.076 0-.188-.134-.188-.334S3.112 7 3.188 7h7.292c.076 0 .187.133.187.333s-.111.334-.187.334Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M1.667 2.333a.333.333 0 0 0-.333.334V4A.333.333 0 1 0 2 4V2.667a.333.333 0 0 0-.333-.334Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgToilet);

/***/ })

}]);